"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firebaseApp = exports.firebase = exports.firebaseConfig = void 0;
// @ts-nocheck
// Native builds get the config from google-services.json GoogleService-Info.plist
const app_1 = __importDefault(require("firebase/compat/app"));
exports.firebase = app_1.default;
require("firebase/compat/auth");
require("firebase/compat/firestore");
require("firebase/compat/messaging");
const sw_1 = require("firebase/messaging/sw");
const constants_1 = require("../../src/constants/constants");
const helpler_1 = require("../../src/utils/helpler");
exports.firebaseConfig = {
    apiKey: process.env.apiKey,
    authDomain: process.env.authDomain,
    projectId: process.env.projectId,
    storageBucket: process.env.storageBucket,
    messagingSenderId: process.env.messagingSenderId,
    appId: process.env.appId,
    measurementId: process.env.measurementId,
};
const firebaseApp = app_1.default.initializeApp(exports.firebaseConfig);
exports.firebaseApp = firebaseApp;
(0, sw_1.isSupported)()
    .then((isSupport) => {
    if (isSupport) {
        (0, sw_1.getMessaging)(firebaseApp);
        self.addEventListener('notificationclick', function (event) {
            const url = event?.notification?.data?.url || '';
            event.notification.close();
            if (url) {
                const directUrl = (0, helpler_1.handleNotification)(url);
                event.waitUntil(clients.matchAll({ includeUncontrolled: true, type: 'window' })
                    .then(async (windowClients) => {
                    // Kiểm tra nếu có cửa sổ nào đang mở
                    for (let windowClient of windowClients) {
                        if (windowClient.navigate) {
                            try {
                                await self.clients.claim();
                                await windowClient.focus();
                                windowClient.postMessage({ action: constants_1.listenerEvents.ON_NOTIFICATION_CLICK, url: directUrl });
                            }
                            catch (error) {
                                console.log('ERROR', error);
                            }
                            return;
                        }
                    }
                    // Nếu không có cửa sổ nào đang mở, mở một cửa sổ mới
                    if (clients.openWindow) {
                        return clients.openWindow(directUrl);
                    }
                }));
            }
        });
        self.addEventListener('push', (event) => {
            const data = event.data.json();
            // Kiểm tra trạng thái của trình duyệt
            if (!(self.registration && self.registration.showNotification)) {
                return;
            }
            // Kiểm tra xem trình duyệt có đang ở chế độ foreground không
            if (self.clients && self.clients.matchAll) {
                event.waitUntil(self.clients.matchAll({ type: 'window', includeUncontrolled: true })
                    .then((clientList) => {
                    for (const client of clientList) {
                        if (client.visibilityState === 'visible') {
                            event.waitUntil(self.registration.showNotification(data.notification.title, {
                                body: data.notification.body,
                                data: data.data,
                                tag: data.fcmMessageId
                            }));
                            event.preventDefault();
                            return;
                        }
                    }
                }));
            }
        });
    }
});
